import React, { useState, useEffect } from "react";
import { Container } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import CustomButton from "../../components/Custom/CustomButton";
import SingleCustomCard from "../../components/Custom/SingleCustomCard";
import LoaderContainer from "../../components/LoaderContainer";
import api from "../../globals/axios";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import { useTranslation } from "react-i18next";
import {
  CustomTitle,
  CustomChartsTitle,
} from "../../components/Custom/CustomTypography";

export default function LoanDocuments() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);
  const [uploadDocuments, setUploadDocuments] = useState(false);

  useEffect(() => {
    api
      .get("/fpo/documents/")
      .then((response) => {
        if (response && response.data) {
          setDocuments(response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
        setLoading(false);
      });
  }, []);

  const handleView = (documentUrl) => {
    window.open(documentUrl, "_blank"); // Open document in a new tab
  };

  const downloadDocument = (documentId) => {
    window.open(
      `${SERVER_BASE_ADDRESS}/fpo/download_file/?identifier=${documentId}&file_type=document`
    );
  };

  const handleDelete = (documentId) => {
    api.delete(`/fpo/document/${documentId}/`).then((response) => {
      console.log("Document deleted successfully", response);
      setDocuments(documents.filter((doc) => doc.id !== documentId));
      alert("Document deleted successfully");
    });
  };

  const handleUploadDocumentButton = () => {
    setUploadDocuments(!uploadDocuments);
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <CustomTitle> {t("Loan Documents")}</CustomTitle>

          <div
            style={{
              height: "71vh",
              marginTop: "20px",
            }}
          >
            <CustomChartsTitle>{t("Financial Documents")}</CustomChartsTitle>
            {documents.map((data) => (
              <SingleCustomCard
                key={data.id}
                data={[{ value: data.name }]}
                onView={() => handleView(data.document)}
                onUpload={() => downloadDocument(data.id)}
                onDelete={() => handleDelete(data.id)}
                showIcons={true}
              />
            ))}
          </div>

          <CustomButton onClick={handleUploadDocumentButton}>
            {t("Upload More Documents")}
          </CustomButton>

          <CustomButton
            onClick={() => {
              console.log("Submit is clicked");
            }}
          >
            {t("Submit")}
          </CustomButton>
        </Container>
      </LoaderContainer>
    </>
  );
}
